export const GET_CREDITS = `
  mutation ($year: Int!, $month: Int) {
    getCredits(actualsSearch: {year: $year, month: $month}) {
      data {
        elementMap {
          element1Id
          element2Id
          element3Id
          element4Id
        }
        totalCredit
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
